import React, { useEffect, useState, useContext } from "react";
import styled from "styled-components";
import { MachinesContext } from "../../_context/MachinesContext";
import { Button } from "../../../../../../ui";

export const RefreshFC = () => {
  const {
    setLoadingMachines,
    setLoadingHHMMachines,
    getMachines,
    getHHMMachines,
  } = useContext(MachinesContext);

  const handleRefresh = () => {
    setLoadingMachines(true);
    setLoadingHHMMachines(true);
    getMachines();
    getHHMMachines();
  };

  useEffect(() => {}, []);

  return (
    <RefreshSC>
      <Button variant="secondary" size="small" onClick={handleRefresh}>
        {window.screen.width > 768 ? "Refresh" : "↻"}
      </Button>
    </RefreshSC>
  );
};

const RefreshSC = styled.div`
  display: inline-block;
`;
